<template>
  <div v-if="courses" class="courses">
    <div v-for="section in courses" :key="section.id" class="section">
      <div class="app-topic-title" @click="section.collapsed = !section.collapsed">
        <span v-if="section.title">{{ section.title }}</span>
        <span v-else></span>
        <span class="icon-collapse" :class="{ collapsed: section.collapsed }"></span>
      </div>

      <div v-if="!section.collapsed" class="content mb-1">
        <div class="courses-list">
          <div v-for="course in section.courses" :key="course.id" class="course" @click="openCourse(course)">
            <div class="title mb-1">
              {{ course.title }}
            </div>
            <div v-if="course.description" class="description mb-1" v-html="course.description"></div>
            <img :src="generateFileUrl(course.preview)" alt="" />
          </div>
        </div>
      </div>
    </div>
    <app-popup v-if="course" name="course-popup" large @close="stopCourse">
      <div class="course__popup" :class="{ 'full-screen': isFullScreen }">
        <iframe class="course__iframe" :src="generateUrl(course.entrypoint)" frameborder="0"></iframe>
        <div class="course__popup-full-page" @click="toggleFullScreen">
          <FullScreenIcon />
        </div>
      </div>
    </app-popup>
  </div>
</template>

<script>
import { generateFileUrl } from '@/utils/http-helper';
import generateUrl from '@/utils/mixins/generate_url';
import appPopup from '@/components/user/app-popup';
import FullScreenIcon from '@/assets/img/icons/full_screen_icon.svg?inline';

export default {
  name: 'e-learning',
  components: {
    appPopup,
    FullScreenIcon,
  },
  mixins: [generateUrl],
  data() {
    return {
      course: null,
      isFullScreen: false,
    };
  },
  computed: {
    courses() {
      return this.$store.getters.getCourses?.sections;
    },
    eventId() {
      return +(this.$route.query.event_id || 0);
    },
  },
  async created() {
    await this.$store.dispatch('getCourses', { event_id: this.eventId });
  },
  mounted() {
    window.addEventListener('message', this.messageHandler, false);

    window.addEventListener('beforeunload', this.stopCourse);
  },
  beforeUnmount() {
    this.stopCourse();
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messageHandler, false);
    this.stopCourse();
  },
  methods: {
    stopCourse() {
      this.$store.dispatch('abandonCourse', { course_id: this.course.id, event_id: this.eventId });
    },
    generateFileUrl(file) {
      return generateFileUrl(file);
    },
    async openCourse(course) {
      this.course = course;
      this.$store.dispatch('togglePopup', { popupName: `course-popup` });
    },
    toggleFullScreen() {
      this.isFullScreen = !this.isFullScreen;
    },
    async startCourse(data) {
      const response = await this.$store.dispatch('startCourse', {
        course_id: this.course.id,
        event_id: this.eventId,
        required_score: data.data.passPoints,
        required_percentage: data.data.passPercent,
      });

      if (!response.status) {
        console.log(response);
        this.$awn.alert('Ошибка при запуске курса');
        this.$store.dispatch('togglePopup', { popupName: null });
        return;
      }
    },
    async messageHandler(event) {
      if (!event.data || typeof event.data !== 'string') return;

      const data = JSON.parse(event.data);

      if (data) {
        console.log(data);

        if (data.type === 'course-started') {
          await this.startCourse(data);
        }

        if (data.type === 'course-restarted') {
          await this.stopCourse();

          await this.startCourse(data);
        }

        if (data.type === 'sendCourseData') {
          this.$store.dispatch('finishCourse', {
            course_id: this.course.id,
            event_id: this.eventId,
            course_percentage: data.data.scorePercent,
            user_score: data.data.scorePoints,
            required_score: data.data.passPoints,
            required_percentage: data.data.passPercent,
          });
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.app-topic-title {
  justify-content: space-between;
  cursor: pointer;
}

.content {
  padding: 1rem 1.75rem;

  background-color: #fff;
}

.courses-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  row-gap: 1.5rem;
  column-gap: 2%;
  font-size: 1rem;

  @include razr767 {
    grid-template-columns: repeat(1, 1fr);
  }
}

.course {
  cursor: pointer;

  img {
    width: 100%;
    height: 350px;
    object-fit: cover;

    @include razr767 {
      height: 200px;
    }
  }

  &:hover {
    .title {
      font-weight: 600;
    }
  }

  .title {
    color: var(--platform-accent-color);
  }
}
.course__popup {
  height: 100%;
  overflow: auto;

  &.full-screen {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999999;
    width: 100vw;
    height: 100vh;

    iframe {
      height: 100%;
      max-height: 100%;
    }
  }

  &-full-page {
    position: absolute;
    bottom: 2rem;
    left: 2.5rem;
    width: 3rem;
    height: 3rem;
    padding: 0.5rem;
    background-color: rgba(255, 255, 255, 0.5);

    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
}
.course__iframe {
  display: block;
  width: 100vw;
  max-width: 100%;

  height: 95svh;
  max-height: calc(80vh - 3rem - 14px);

  @include razr767 {
    height: calc(98svh - 6rem);
  }
}
</style>
